import type { CardWrapperProps } from './types'

import * as S from './styles'

export const CardWrapper = ({ children, ...rest }: CardWrapperProps) => {
  return <S.Container {...rest}>{children}</S.Container>
}
